/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState } from "react"

import axios from "axios"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./subscribe-third.module.scss"
import GrowthChannel from "../../../helpers/growth-channel"
import UrlFunctions from "../../../helpers/url"
import TennisImg from "../../../images/scenes/tennis.jpg"
import TennisVideo from "../../../images/scenes/tennis.mp4"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import ButtonGroup from "../button-group"

const SubscribeThird = ({ data, home, all, bg, email }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  const [successBody, setSuccessBody] = useState(data.success._rawDefault)
  const [ctas, setCtas] = useState(data.ctas.ctas || [])

  useEffect(() => {
    const successMsg = GrowthChannel(data.success.growth_channel)
    if (successMsg) {
      setSuccessBody(successMsg._rawDescription)
    } else if (
      data.success._rawReferral &&
      UrlFunctions.getParams().referralcode
    ) {
      setSuccessBody(data.success._rawReferral)
    }
  }, [])

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (email || emailRegex.test(email))
      axios
        .get(
          `https://sniperl.ink/v1/render?recipient=${email}&sender=hi@thegistsports.com`
        )
        .then((response) => {
          if (response.data) {
            const newCtas = data.ctas.ctas
            newCtas.unshift({
              variant: "primary",
              text: `${
                allSanityDictionary.nodes.find(
                  (item) => item.key.current === "sniper_link_cta"
                )?.value
              }${response.data.provider_pretty}`,
              url: response.data.url,
            })
            setCtas(newCtas)
          }
        })
  }, [email])

  const headerLevel = () => {
    if (home) {
      return "3"
    }
    if (all) {
      return "4"
    }
    return "1"
  }

  const content = (
    <div className={styles.content}>
      <Heading level={headerLevel()}>{data.success.title}</Heading>
      <CopyContainer content={successBody} bg={bg} />
      <ButtonGroup ctas={ctas} external variant="secondary" />
    </div>
  )

  if (home || all) {
    return content
  }
  return (
    <Grid className={styles.grid} col={2}>
      <div>
        <video
          className={styles.video}
          poster={TennisImg}
          controls={!!data.success.video}
          loop
          autoPlay
          muted
        >
          <source
            src={
              data.success.video ? data.success.video.asset.url : TennisVideo
            }
            type="video/mp4"
          />
        </video>
      </div>
      {content}
    </Grid>
  )
}

export default SubscribeThird

SubscribeThird.propTypes = {
  data: PropTypes.object.isRequired,
  home: PropTypes.bool,
  all: PropTypes.bool,
  bg: PropTypes.bool,
  email: PropTypes.string,
}

SubscribeThird.defaultProps = {
  home: false,
  all: false,
  bg: true,
  email: null,
}
